import { AxiosResponse } from 'axios'
import { api } from '@/lib/api-client.ts'

export type ResetPasswordData = {
  email: string
}
export const requestResetPasswordLink = async (
  resetPasswordData: ResetPasswordData,
): Promise<AxiosResponse> => {
  return api.post(`/reset_password/`, resetPasswordData)
}

export const validateRequestToken = async (token: string): Promise<AxiosResponse> => {
  return api.get(`/reset_password/${token}?date=` + new Date().getTime())
}

export const resetPassword = async (token: string, password: string): Promise<AxiosResponse> => {
  return api.post(`/reset_password/${token}`, { password })
}
